import {
  KYDAdminEvent,
  KYDAdminEventDetailSection,
  KYDEventReports,
} from "@common/interfaces/KYDEvent";
import { sectionsComponents } from "./sectionsComponents";
import { Stack } from "@chakra-ui/react";
import { EditModalType } from "src/utils";
import React from "react";
import ErrorBoundary from "./ErrorBoundary";
import { matchPath, useLocation } from "react-router-dom";

const EventDetailSections = ({
  sections = [],
  onUpdateEvent,
  setModalType,
  modalType,
  isLoading,
  refetchEvent,
  reports,
}: {
  sections: KYDAdminEventDetailSection[];
  modalType?: EditModalType;
  isLoading: boolean;
  onUpdateEvent: (key: string, override_value?: string) => Promise<void>;
  setModalType: (value: React.SetStateAction<EditModalType>) => void;
  refetchEvent?: (options: any) => Promise<KYDAdminEvent>;
  reports?: KYDEventReports;
}) => {
  const location = useLocation();
  const isDetailTab = Boolean(
    matchPath(
      {
        path: "/events/:event_id",
        end: true,
      },
      location.pathname
    )
  );

  return (
    <Stack
      maxW={["full", "5xl"]}
      w="full"
      spacing={{ base: 5, md: 6 }}
    >
      {sections.map((section) => {
        const Component = sectionsComponents[section.type];
        if (!Component) {
          console.warn(
            `Skipping rendering ${section.type}. No component ${section.type} supported.`
          );
          return null;
        }

        return (
          <ErrorBoundary key={section.type}>
            <Component
              data={section.data}
              permissions={
                section.type === "summary" && !isDetailTab
                  ? section.permissions.filter(
                      (permission) => permission !== "write"
                    )
                  : section.permissions
              }
              isLoading={isLoading}
              reports={reports}
              modalType={modalType}
              refetchEvent={refetchEvent}
              setModalType={setModalType}
              onUpdateEvent={onUpdateEvent}
            />
          </ErrorBoundary>
        );
      })}
    </Stack>
  );
};

export default EventDetailSections;
